import rp, { CodeEditorAdapter, CodeEditorOptions, ContentOptions } from "@reporting/rp-app-host";
import { ContextData, ReportContext } from "@reporting/rp-types/analytics";
import { BaseVisualization } from "../components/visualizations";
import { actions } from "@omegagrid/core";
import { Project, Resource } from "@reporting/rp-types/ext";

export class ContextScriptCodeEditorAdapter extends CodeEditorAdapter {

	constructor(
		private reportContext: ReportContext,
		private getVisualizationComponent: () => BaseVisualization
	) { super() }

	async getContent(opt?: ContentOptions): Promise<string> {
		const context = this.reportContext.context as ContextData;
		return context?.scripts?.[0]?.source ?? '';
	}

	save(data: string) {
		const context = this.reportContext.context as ContextData;
		const script = context?.scripts?.[0] ?? {};
		script.source = data;
		context.scripts = [script];
		return false;
	}

	run() {
		const context = this.reportContext.context as ContextData;
		const component = this.getVisualizationComponent();
		if (component) {
			try {
				component.refresh(context);
			} catch (e) {
				rp.host.showAlert({ content: e.message || 'Error applying script', type: 'danger' });
				console.error(e);
			}
		}
	}

	onAction(action: actions.Action) {
		if (action.key === 'run') {
			this.save(this.component.editor.content);
			this.run();
		}
	}

	private _resources: Resource[];

	async getOptions(): Promise<CodeEditorOptions> {
		if (!this._resources) {
			try	{
				const project = await rp.ms('extensions').get<Project>('projects/__visualizations__');
				this._resources = await rp.ms('extensions').get<Resource[]>('resources', {where: {id_custom_page: project.id_custom_page}});
			} catch (e) {
				this._resources = [];
			}
		}

		const context = this.reportContext.context as ContextData;
		const script = context?.scripts?.[0] ?? {};

		return this.createOptions({
			language: 'javascript',
			toolbar: {
				save: { enabled: false },
				discard: { enabled: false },
				run: { id: 'run', enabled: true, type: 'button', icon: { icon: ['fas', 'play'], color: 'green' } },
				scripts: { id: 'scripts', enabled: true, type: 'dropdown', value: (script.id_custom_resource || '0').toString(), items: [
					{ k: '0', v: '<script>' },
					...this._resources.map(r => ({k: r.id_custom_resource.toString(), v: r.name}))
				], width: 200 }
			}
		});
	}

}
